import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FullLoader } from "@/components/cast/Common";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const done = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const q = new URLSearchParams(loc.search);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect_uri = window.location.origin + "/auth/google";
    if (!q.get("code")) { setErr(q.get("error") === "access_denied" ? "Google sign-in was cancelled." : "Google sign-in didn't complete."); return; }
    api.post("/auth/google/exchange", { code: q.get("code"), state: q.get("state"), redirect_uri })
      .then(({ data }) => { setUser(data); nav(data.onboarded ? "/shore" : "/onboarding", { replace: true }); })
      .catch((e) => setErr(errMsg(e)));
  }, [loc.search, nav, setUser]);

  if (!err) return <FullLoader />;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#FAF7F2] p-6 text-center" data-testid="google-auth-error">
      <p className="font-display text-3xl text-slate-900">We couldn't sign you in</p>
      <p className="text-slate-600">{err}</p>
      <Link to="/login" replace className="rounded-full bg-[#1E293B] px-6 py-2.5 font-semibold text-white" data-testid="google-auth-retry">Back to sign in</Link>
    </div>
  );
}
